import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { GPIOReading } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputSelect, DataSourceLookup, InputDateTime, DateComp } from '@/components';
import { useEventCommonStore } from '@/stores';
import { storeToRefs } from 'pinia';
import { type DateType } from '@/utilities/dateutils';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class GPIOReadingGuiDef extends GuiDef<GPIOReading> {
    constructor() {
        super('GPIOReading');

        const EventCommon = storeToRefs(useEventCommonStore());
        const StationsSource = computed(() => {
            return EventCommon.StationsAsSelectLine.value;
        });

        const StationID = new FieldDef<GPIOReading>();
        StationID.Name = 'StationID';
        StationID.FieldName = 'StationID';
        StationID.DefinedFor = 'Both';
        StationID.TranslationKey = 'gpioreading.stationid';
        StationID.Editable = true;
        StationID.Filterable = true;
        StationID.Sortable = true;
        StationID.CssClasses = '';
        StationID.value = (gpioreading) => gpioreading.StationID;
        StationID.setValue = (gpioreading, value) => {
            if (value === null || value === undefined || value === '' || isNaN(value)) {
                value = 0;
            }
            gpioreading.StationID = value;
        };
        StationID.DetailEditor = markRaw(InputSelect);
        StationID.DetailEditorProps = { datasource: { mapsource: StationsSource } };
        StationID.CellEditor = markRaw(InputSelect);
        StationID.CellEditorProps = { datasource: { mapsource: StationsSource } };
        // @ts-expect-error @ts-ignore
        StationID.CellRenderer = markRaw(DataSourceLookup);
        StationID.CellRendererProps = { datasource: { mapsource: StationsSource } };
        StationID.ExportValueFormatter = (obj: GPIOReading) => {
            return StationsSource.value.get(obj.StationID)?.text;
        };
        StationID.Validator = null;
        StationID.SortDirection = undefined;
        StationID.cellClassRules = undefined;
        StationID.MinWidth = undefined;
        StationID.MaxWidth = undefined;
        StationID.Tooltip = null;
        this.Fields.push(StationID);

        const Time = new FieldDef<GPIOReading>();
        Time.Name = 'Time';
        Time.FieldName = 'Time';
        Time.DefinedFor = 'Both';
        Time.TranslationKey = 'gpioreading.time';
        Time.Editable = true;
        Time.Filterable = true;
        Time.Sortable = true;
        Time.CssClasses = '';
        Time.value = (gpioreading) => gpioreading.Time;
        Time.setValue = (gpioreading, value) => (gpioreading.Time = value);
        Time.DetailEditor = markRaw(InputDateTime);
        Time.DetailEditorProps = { format: 'DATETIMEMS3' as DateType };
        Time.CellEditor = markRaw(InputDateTime);
        Time.CellEditorProps = { format: 'DATETIMEMS3' as DateType };
        Time.CellRenderer = markRaw(DateComp);
        Time.CellRendererProps = { format: 'DATETIMEMS3' as DateType };
        Time.Validator = null;
        Time.SortDirection = undefined;
        Time.cellClassRules = undefined;
        Time.MinWidth = 220;
        Time.MaxWidth = undefined;
        Time.Tooltip = null;
        this.Fields.push(Time);
    }

    public async LoadDependencies() {
        await useEventCommonStore().EnsureLoaded(['Stations']);
    }
}
